'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _package = require('../../package.json');

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BotActionDiagnostics = function (_React$Component) {
  _inherits(BotActionDiagnostics, _React$Component);

  function BotActionDiagnostics() {
    _classCallCheck(this, BotActionDiagnostics);

    return _possibleConstructorReturn(this, (BotActionDiagnostics.__proto__ || Object.getPrototypeOf(BotActionDiagnostics)).apply(this, arguments));
  }

  _createClass(BotActionDiagnostics, [{
    key: 'render',
    value: function render() {
      var result = this.props.response.queryResult;
      var context = result.search && result.search.context;

      return _react2.default.createElement(
        'div',
        { className: 'diagnostic' },
        _package2.default.version && 'v: [' + _package2.default.version + ']',
        this.props.botProjectId && ', bot: [' + this.props.botProjectId + ']',
        result.intent && ', intent: [' + result.intent.displayName + ']',
        result.sentimentAnalysisResult && ', sentiment: [' + result.sentimentAnalysisResult.queryTextSentiment.score + ']',
        this.props.productId && ', product: [' + this.props.productId + ']',
        context && ', query: [' + context.query + '], type: [' + context.type + '], field: [' + context.field + ']'
      );
    }
  }]);

  return BotActionDiagnostics;
}(_react2.default.Component);

exports.default = BotActionDiagnostics;


BotActionDiagnostics.propTypes = {
  response: _propTypes2.default.object.isRequired,
  productId: _propTypes2.default.string,
  botProjectId: _propTypes2.default.string
};